import { AuthenticationResponse } from "services/facultyPortalClient";
import authStore, { USER_STORAGE_KEY, AuthStore } from "stores/authStore";
import { ClaimType, UserClaim } from "types/claimTypes";

export const buildAuthentication = (
  authenticationResponse: AuthenticationResponse
) => {
  createUserClaim(authenticationResponse);

  const userRaw = global.localStorage.getItem(USER_STORAGE_KEY);
  const userData = JSON.parse(userRaw!) as AuthStore;

  authStore.update((s) => {
    Object.assign(s, {
      ...userData,
      isLoggedIn: true
    });
  });
};

export const clearAuthentication = () => {
  authStore.update((s) => {
    s.isLoggedIn = false;
    s.firstName = null;
    s.lastName = null;
    s.email = null;
    s.organizationId = null;
    s.impersonatingUserEmail = null;
    s.id = null;
  });

  global.localStorage.clear();
};

export const hasUserPermission = (
  parentClaim: string,
  claimResource: string,
  claimPermission: string
) => {
  const userRaw = global.localStorage.getItem(USER_STORAGE_KEY);
  if (!userRaw) {
    return false;
  }

  const userData = JSON.parse(userRaw) as AuthStore;
  if (!userData) {
    return false;
  }

  return userData.claims?.some(
    (c) =>
      c?.claimType === ClaimType.Permission &&
      c?.parentClaim === parentClaim &&
      c?.claimResource === claimResource &&
      c?.claimPermission === claimPermission
  );
};

const createUserClaim = (userResponse: AuthenticationResponse) => {
  const claims = userResponse.permissions?.map((perm: string) => {
    try {
      const splitted = perm.split(".");

      return {
        claimType: ClaimType.Permission,
        parentClaim: splitted[0],
        claimResource: splitted[1],
        claimPermission: splitted[2],
      } as UserClaim;
    } catch {
      console.log("There are permissions not properly processed.");
      // eslint-disable-next-line array-callback-return
      return;
    }
  });

  const userAuthStore: AuthStore = {
    id: userResponse.id ?? null,
    email: userResponse.email,
    firstName: userResponse.firstName,
    lastName: userResponse.lastName,
    organizationId: userResponse.organizationId,
    isLoggedIn: true,
    impersonatingUserEmail: userResponse.impersonatedUserEmail,
    claims: claims ?? [],
  };

  global.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(userAuthStore));

  authStore.update((s) => {
    Object.assign(s, {
      ...userAuthStore,
      isLoggedIn: true
    });
  });
};
